import { HStack, Stack, UI, VStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import {
  ButtonSkeleton,
  DetailsSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import {
  ApplicationInfoLoading,
  FeeInfoLoading,
  MaturityInfoLoading,
  NetValueInfoLoading,
  ProfitabilityInfoLoading,
  RiskInfoLoading,
  TaxInfoLoading,
  UnitPriceInfoLoading,
} from '../shared';

export const ListLoadingItemDesktop: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  return (
    <TableContent direction="column" space="stack.xxxs" p={0} px="inline.xxxs" py="stack.xxxs">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <HStack justifyContent="space-between" w="full">
        <Stack w="1/6">
          <HStack space="inline.xxxs" alignItems="center">
            <DetailsSkeleton />
            <TextSkeleton hasCaptions />
          </HStack>
        </Stack>
        <ApplicationInfoLoading w="1/6" />
        <RiskInfoLoading w="1/6" />
        <TaxInfoLoading w="1/6" />
        <ProfitabilityInfoLoading w="1/6" />
        <MaturityInfoLoading w="1/6" />
      </HStack>
      <HStack justifyContent="space-between" w="full" alignItems="center">
        <Stack w="1/6">
          <VStack space="stack.quarck" justifyContent="space-between">
            <HStack space="inline.quarck" alignItems="center">
              <UI.Text variant="semibold">Taxa</UI.Text>
              <UI.Text fontSize="xs">(Spread)</UI.Text>
            </HStack>
            <Stack pr="inline.xxxs">
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <UnitPriceInfoLoading w="1/6" />
        <FeeInfoLoading w="1/6" />
        <Stack w="1/6">
          <VStack space="stack.quarck" justifyContent="space-between">
            <UI.Text variant="semibold">Valor a aplicar</UI.Text>
            <Stack pr="inline.xxxs">
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <NetValueInfoLoading w="1/6" />
        <Stack w="1/6">
          <ButtonSkeleton />
        </Stack>
      </HStack>
    </TableContent>
  );
};
